import React, { useEffect, useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import SearchBar, { matches, snippet } from '../components/SearchBar';
import ShareButton from '../components/ShareButton';

// Page Cards : les paquets de cartes de révision. Un clic ouvre le lecteur plein écran (façon Reels).
const plural = (n, word) => `${n} ${word}${n > 1 ? 's' : ''}`;

export default function Cards() {
  const [decks, setDecks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [params, setParams] = useSearchParams();
  const query = params.get('q') || '';
  const setQuery = (v) => { const n = new URLSearchParams(params); if (v) n.set('q', v); else n.delete('q'); setParams(n, { replace: true }); };
  // on cherche dans le titre, la description et le texte de toutes les cartes du paquet
  const shown = useMemo(() => decks.filter(d => matches(query, d.title, d.description, d.text)), [decks, query]);

  useEffect(() => {
    fetch('/api/cards/decks')
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(setDecks)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="section fade-in">
      <div className="section-head">
        <h2>cards</h2>
        <span className="head-right">
          <span className="counter">{String(decks.length).padStart(2, '0')} paquet{decks.length > 1 ? 's' : ''}</span>
          <ShareButton variant="icon" title="Cards — Zahra's Learning" text="Des cartes de révision à faire défiler comme des Reels" />
        </span>
      </div>

      {loading ? <div className="empty-state">chargement...</div> :
       error ? <div className="empty-state">impossible de charger les cartes pour le moment — réessayez dans un instant.</div> :
       decks.length === 0 ? <div className="empty-state">rien encore ici ✦</div> : (
        <>
          <p className="qcm-intro-line">Des cartes de révision à faire défiler, une par écran — glissez vers le haut pour passer à la suivante.</p>
          <SearchBar value={query} onChange={setQuery} placeholder="Rechercher un paquet ou une notion…" label="Rechercher dans les cartes"
            count={shown.length} total={decks.length} unit="paquet" />
          {shown.length === 0 && (
            <div className="empty-state search-empty">
              aucun paquet pour « {query} »
              <button type="button" className="btn secondary" onClick={() => setQuery('')}>voir tous les paquets</button>
            </div>
          )}
          <div className="deck-grid">
            {shown.map((d, i) => {
              const inCards = query && !matches(query, d.title, d.description) ? snippet(query, d.text, 70) : '';
              return (
              <Link key={d.id} to={`/cards/${d.id}`} className={`deck-tile tone-${d.id % 4} ${d.thumb ? 'has-thumb' : ''}`}>
                {d.thumb
                  ? <img className="deck-thumb" src={d.thumb} alt="" loading="lazy" />
                  : <span className="deck-glyph" aria-hidden="true">✦</span>}
                <span className="deck-stack" aria-hidden="true" />
                <span className="deck-info">
                  <span className="deck-count">
                    <PlayIcon /> {plural(d.card_count, 'carte')}{d.video_count ? ` · ${plural(d.video_count, 'vidéo')}` : ''}
                  </span>
                  <span className="deck-title">{d.title}</span>
                  {inCards
                    ? <span className="deck-match">dans les cartes : « {inCards} »</span>
                    : d.description && <span className="deck-desc">{d.description}</span>}
                </span>
              </Link>
              );
            })}
          </div>
        </>
      )}
    </section>
  );
}

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="deck-play"><path d="M8 5.5v13l11-6.5z" fill="currentColor" /></svg>
);
